export default __webpack_public_path__ + "static/cs-deloitte-f7703a1bbf3c22b18018371fb0f1a09c.webp";